var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.76 58C45.672 58 58.56 45.112 58.56 29.2C58.56 13.288 45.672 0.400024 29.76 0.400024C13.848 0.400024 0.959961 13.288 0.959961 29.2C0.959961 45.112 13.848 58 29.76 58Z",
    fill: "url(#paint0_linear_610_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.258 29.254C54.258 23.458 52.206 17.86 48.462 13.432L51.576 10.318L48.642 7.38403L45.528 10.498C36.348 2.74003 22.92 2.79403 13.812 10.624L10.698 7.49203L7.72801 10.426L10.86 13.558C9.29401 15.43 8.01601 17.536 7.08001 19.786H11.31C16.53 9.61603 29.004 5.60203 39.192 10.822C49.38 16.042 53.376 28.516 48.174 38.704C42.972 48.892 30.48 52.888 20.292 47.686C16.422 45.688 13.254 42.538 11.292 38.65H7.06201C8.03401 40.954 9.34801 43.132 10.968 45.058L7.85401 48.172L10.788 51.106L13.902 47.974C22.974 55.66 36.276 55.696 45.42 48.1L48.534 51.214L51.468 48.28L48.39 45.166C52.188 40.738 54.258 35.068 54.258 29.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.046 34.924L11.634 31.27H15.108V29.902H3.71404V31.27H7.18805L4.77604 34.924H6.57604L9.42004 30.64L12.264 34.924H14.046ZM15.09 28.552V27.148H11.688L14.064 23.53H12.264L9.40205 27.886L6.54004 23.53H4.74004L7.11605 27.148H3.69604V28.552H15.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3261 37.0661L24.7021 33.3401C26.4301 34.6181 27.7801 35.1401 29.1301 35.1401C30.7501 35.1401 31.3621 34.5821 31.3621 33.3401C31.3621 30.7661 23.0821 30.4241 23.0821 24.7901C23.0821 20.8661 25.7461 18.4361 30.0841 18.4361C32.9101 18.4361 34.9081 19.5881 36.4741 21.2621L33.7561 24.4121C32.6041 23.3681 31.6141 22.8641 30.4081 22.8641C29.0401 22.8641 28.3561 23.2421 28.3561 24.5201C28.3561 26.9501 36.6361 27.0941 36.6361 32.9261C36.6361 36.7061 34.2061 39.5501 29.1301 39.5501C27.2041 39.5681 24.2341 38.8121 22.3081 37.0661H22.3261ZM27.2761 15.3041H32.2081V20.1281H27.2761V15.3041ZM27.2761 37.2641H32.2081V42.7361H27.2761V37.2641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_610_242",
    x1: 48.804,
    y1: 48.622,
    x2: 10.356,
    y2: 9.40002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#585EFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#626BFF",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7481FF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8799FF",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.6,
    height: 57.6,
    fill: "white",
    transform: "translate(0.959961 0.400024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXUsd);
export default __webpack_public_path__ + "static/media/xUSD.e94c1827d5f1dce5468abdbf90b23ee8.svg";
export { ForwardRef as ReactComponent };